/**
 * Issue-type + confidence display mapping (Figma 30979-18328 / 30947-17310).
 * The rca category is "family/detail" ("application_issue/functional_defect")
 * — the FAMILY drives the chip; the confidence 0..1 drives the drawer bar.
 */

export function issueTypeFromCategory(category) {
  var family = (category !== null && category !== void 0 ? category : '').split('/')[0].toLowerCase();
  if (family.startsWith('application')) {
    return {
      key: 'application',
      label: 'Application issue'
    };
  }
  if (family.startsWith('environment')) {
    return {
      key: 'environment',
      label: 'Environment issue'
    };
  }
  if (family.startsWith('automation')) {
    return {
      key: 'automation',
      label: 'Automation bug'
    };
  }
  return {
    key: 'other',
    label: 'Issue'
  };
}

/** Chip tooltip: the pack's full classification, not just the family —
 * "environment_issue/bot_detection" → "Environment issue · Bot detection".
 * Producers sometimes repeat the family ("application_issue/
 * application_issue/functional_defect"); the LAST segment is the entity.
 * No detail segment → just the family label. */
export function issueTypeTooltip(category) {
  var _issueTypeFromCategor = issueTypeFromCategory(category),
    label = _issueTypeFromCategor.label;
  var segments = (category !== null && category !== void 0 ? category : '').split('/').filter(Boolean);
  if (segments.length < 2) return label;
  var detail = segments[segments.length - 1].replace(/_/g, ' ').trim();
  if (detail === '') return label;
  return "".concat(label, " \xB7 ").concat(detail.charAt(0).toUpperCase()).concat(detail.slice(1));
}
export function confidenceInfo(confidence) {
  if (typeof confidence !== 'number' || Number.isNaN(confidence)) return null;
  var pct = Math.round(Math.min(1, Math.max(0, confidence)) * 100);
  if (pct >= 80) return {
    pct: pct,
    label: 'High',
    color: '#1a7f37'
  };
  if (pct >= 50) return {
    pct: pct,
    label: 'Medium',
    color: '#bf8700'
  };
  return {
    pct: pct,
    label: 'Low',
    color: '#cf222e'
  };
}

/** triage.severity (closed producer enum) → the report pill palette.
 * Unknown/absent values map to null — render no pill rather than lie. */
export function severityToPill(severity) {
  switch ((severity !== null && severity !== void 0 ? severity : '').toLowerCase()) {
    case 'critical':
      return 'P0';
    case 'major':
      return 'P1';
    case 'minor':
      return 'P2';
    case 'cosmetic':
      return 'Gap';
    default:
      return null;
  }
}